export default __webpack_public_path__ + "static/media/Cost.d185a63d.svg";